/* eslint-disable react/no-array-index-key */
import * as React from 'react'
// import NextLink from 'next/link'
import styled from 'styled-components'
import { filterThousands, filterPrecision, filterAbbreviation, verifyValidNumber } from 'utils/tools'
import { useMount, useCountDown, useInterval } from 'ahooks'
import { SdkProvider, getPrecision, DashboardGLPPrice } from 'gby-sdk'
import type {
  BuySellTokenBalance,
  DashboardGLPPriceHistory,
  DashboardGLPLiquidityComposition,
  DashboardGLPPoolPosition,
  BuyGLPInfo,
  PreBuyGLPInfo,
  SellGLPInfo,
  PreSellGLPInfo,
} from 'gby-sdk'
// import ConnectWalletButton from 'components/ConnectWalletButton'
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import dayjs from 'dayjs'
import { useWalletClient } from 'wagmi'
import { useMatchBreakpoints } from '@pancakeswap/uikit'
import { ContainerCoin, ContainerAuth } from '../../componentsNew/_global'
import FooterNew from '../../components/FooterNew'
import { Button, Modal, Input, Table, Trigger, Circle, Tooltip as TooltipNew } from '../../componentsNew'
import type { ColumnObjectType, TableObjectType } from '../../componentsNew'
import { IconSelectArrow } from '../../assets/icons/IconGroup'

const Wrapper = styled.div`
  .up {
    color: rgba(69, 198, 24, 1) !important;
  }
  .down {
    color: rgba(221, 20, 68, 1) !important;
  }
  .dotted-line {
    border-bottom: 1px dashed rgba(255, 255, 255, 0.45);
  }
  @media not screen and (max-width: 1280px) {
    .inner {
      margin: 0 auto;
      padding: 40px 0 80px 0;
      /* width: 1200px; */
      width: 996px;
    }
    .title {
      color: #fff;
      font-size: 30px;
      font-style: italic;
      font-weight: 900;
      line-height: 100%;
    }
    .title-tips {
      margin: 12px 0 24px 0;
      color: rgba(255, 255, 255, 0.45);
      font-size: 14px;
      font-weight: 300;
      line-height: 100%;
    }
    .labor {
      margin-bottom: 80px;
      padding: 16px;
      border-radius: 24px;
      background: var(--agniBG, rgba(47, 40, 40, 0.5));
      .coin {
        margin-bottom: 24px;
        img {
          width: 36px;
          height: 36px;
        }
        h3 {
          margin-left: 8px;
          color: #fff;
          font-size: 18px;
          font-weight: 700;
        }
        .each {
          position: relative;
          margin-right: 20px;
          img:nth-child(2) {
            position: absolute;
            top: 0;
            left: 20px;
          }
        }
      }
      .box {
        flex: 1;
        align-items: stretch;
      }
      .chart {
        height: 140px;
        /* color: #fff;
        border-radius: 24px;
        background: rgba(255, 255, 255, 0.05); */
        .xAxis {
          text {
            fill: rgba(244, 196, 112, 0.65);
          }
          tspan {
            font-size: 12px;
            font-weight: 400;
            line-height: 100%;
          }
        }
        .recharts-default-tooltip {
          padding: 12px;
        }
        .recharts-tooltip-label {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          font-weight: 400;
        }
        .recharts-tooltip-item {
          margin-top: 4px;
          span {
            font-size: 14px;
            font-weight: 400;
          }
          span:nth-child(1) {
            color: rgba(255, 255, 255, 0.85);
          }
        }
      }
      hr {
        margin: 0 24px;
        width: 1px;
        height: 168px;
        background: rgba(255, 255, 255, 0.12);
      }
      .info {
        h4 {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          font-weight: 400;
        }
        p {
          color: #fff;
          font-size: 14px;
          font-weight: 600;
        }
      }
      .info-only {
        svg {
          margin-right: 4px;
          fill: #f4c470;
        }
        p {
          color: #f4c470;
        }
      }
      .info + .info {
        margin-top: 10px;
      }
      .reward {
        height: 24px;
      }
      .button {
        margin-top: 24px;
        gap: 8px;
      }
      .button-only {
        flex: 1;
      }
      /* .min {
        max-width: 128px;
      } */
    }
    .detail {
      margin-bottom: 80px;
      .subtitle {
        margin-bottom: 16px;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
      }
      .box {
        align-items: stretch;
        gap: 16px;
        border-radius: 24px;
        background: var(--agniBG, rgba(47, 40, 40, 0.5));
        overflow: hidden;
      }
      .left {
        width: 280px;
        padding: 16px 16px 24px 16px;
        border-right: 1px solid rgba(255, 255, 255, 0.08);
        .chart {
          position: relative;
          width: 248px;
          height: 242px;
          h4 {
            position: relative;
            color: #fff;
            text-align: center;
            font-size: 18px;
            font-weight: 700;
            z-index: 1;
          }
          p {
            position: relative;
            margin-top: 8px;
            color: rgba(255, 255, 255, 0.45);
            text-align: center;
            font-size: 12px;
            z-index: 1;
          }
        }
        .chart-info {
          width: 188px;
          height: 188px;
          border-radius: 50%;
          /* background: rgba(255, 255, 255, 0.05); */
          /* 准备删除 */
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        hr {
          margin: 16px 0;
          width: 100%;
          height: 1px;
          background: rgba(255, 255, 255, 0.08);
        }
        .info {
          flex-wrap: wrap;
          .only {
            width: 50%;
          }
          .only:nth-child(2n) {
            padding-left: 12px;
          }
          .only:nth-child(n + 3) {
            margin-top: 10px;
          }
          .dot {
            margin-right: 4px;
            width: 8px;
            height: 8px;
          }
          .color_0 {
            background: #f4c470;
          }
          .color_1 {
            background: #3eac35;
          }
          .color_2 {
            background: #ff7f3f;
          }
          .color_3 {
            background: #ea5c2b;
          }
          p {
            color: rgba(255, 255, 255, 1);
            font-size: 12px;
          }
        }
      }
      .right {
        flex: 1;
        .table {
          /* height: 316px;
          overflow-y: auto; */
          padding-bottom: 8px;
        }
        th:nth-child(1),
        td:nth-child(1) {
          padding-left: 0;
        }
        td:first-child {
          span {
            font-weight: 700;
          }
        }
        th {
          font-size: 12px;
        }
        td {
          div {
            text-align: left !important;
          }
        }
        thead {
          position: sticky;
          top: 0;
          background: rgb(23, 20, 20);
        }
        .coin {
          margin-right: 8px;
          width: 32px;
          height: 32px;
        }
      }
    }
    .pool {
      .info {
        margin-bottom: 12px;
        padding: 32px 0px;
        gap: 24px;
        border-radius: 24px;
        background: var(--agniBG, rgba(47, 40, 40, 0.5));
        div {
          flex: 1;
        }
        p {
          color: rgba(255, 255, 255, 0.45);
          text-align: center;
          font-size: 14px;
        }
        h4 {
          margin-top: 12px;
          color: #fff;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
        }
      }
      .table {
        padding: 0px 16px 32px 16px;
        height: 320px;
        overflow-y: auto;
        border-radius: 24px;
        background: var(--agniBG, rgba(47, 40, 40, 0.5));
      }
      th {
        height: 46px;
      }
      td {
        height: 40px;
        div {
          text-align: left !important;
        }
      }
      td:first-child {
        span {
          font-weight: 700;
        }
      }
      td:last-child {
        width: 15%;
      }
      thead {
        position: sticky;
        top: 0;
        background: rgb(23, 20, 20);
      }
    }
  }
  @media screen and (max-width: 1280px) {
    .inner {
      padding: 24px 16px 48px 16px;
    }
    .title {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      line-height: 100%;
    }
    .title-tips {
      margin: 12px 0 16px 0;
      color: rgba(255, 255, 255, 0.45);
      font-size: 14px;
      line-height: 120%;
    }
    .labor {
      margin-bottom: 48px;
      padding: 16px 12px;
      border-radius: 24px;
      background: var(--agniBG, rgba(47, 40, 40, 0.5));
      .labor-box {
        display: block;
      }
      .coin {
        margin-bottom: 24px;
        img {
          width: 32px;
          height: 32px;
        }
        h3 {
          margin-left: 8px;
          color: #fff;
          font-size: 16px;
          font-weight: 700;
        }
        .each {
          position: relative;
          margin-right: 20px;
          img:nth-child(2) {
            position: absolute;
            top: 0;
            left: 20px;
          }
        }
      }
      .box {
        flex: 1;
        align-items: stretch;
      }
      .chart {
        height: 140px;
        /* color: #fff;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.05); */
        .xAxis {
          text {
            fill: rgba(244, 196, 112, 0.65);
          }
          tspan {
            font-size: 12px;
            font-weight: 400;
            line-height: 100%;
          }
        }
        .recharts-tooltip-wrapper {
          outline: none;
        }
        .recharts-default-tooltip {
          padding: 12px;
        }
        .recharts-tooltip-label {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          font-weight: 400;
        }
        .recharts-tooltip-item {
          margin-top: 4px;
          span {
            font-size: 14px;
            font-weight: 400;
          }
          span:nth-child(1) {
            color: rgba(255, 255, 255, 0.85);
          }
        }
      }
      hr {
        margin: 24px 0;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.12);
      }
      .info {
        h4 {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          font-weight: 400;
        }
        p {
          color: #fff;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .info-only {
        p {
          color: #f4c470;
        }
      }
      .info + .info {
        margin-top: 10px;
      }
      .reward {
        height: 24px;
      }
      .button {
        margin-top: 24px;
        display: block;
      }
      .min {
        margin-top: 8px;
      }
    }
    .detail {
      margin-bottom: 48px;
      .subtitle {
        margin: 32px 0 24px 0;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
      }
      .box {
        display: block;
        padding: 16px 12px;
        border-radius: 24px;
        background: var(--agniBG, rgba(47, 40, 40, 0.5));
        overflow: hidden;
      }
      .left {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .chart {
          position: relative;
          width: 128px;
          height: 128px;
          h4 {
            position: relative;
            color: #fff;
            text-align: center;
            font-size: 12px;
            font-weight: 700;
            z-index: 1;
          }
          p {
            position: relative;
            margin-top: 6px;
            color: rgba(255, 255, 255, 0.45);
            text-align: center;
            font-size: 8px;
            z-index: 1;
          }
        }
        .chart-info {
          width: 128px;
          height: 128px;
          border-radius: 50%;
          /* background: rgba(255, 255, 255, 0.05); */
          /* 准备删除 */
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        hr {
          margin: 0 24px;
          width: 1px;
          height: 96px;
          background: rgba(255, 255, 255, 0.08);
        }
        .info {
          display: block;
          min-width: 108px;
          .only + .only {
            margin-top: 16px;
          }
          .dot {
            margin-right: 4px;
            width: 8px;
            height: 8px;
          }
          .color_0 {
            background: #f4c470;
          }
          .color_1 {
            background: #3eac35;
          }
          .color_2 {
            background: #ff7f3f;
          }
          .color_3 {
            background: #ea5c2b;
          }
          p {
            color: rgba(255, 255, 255, 1);
            font-size: 12px;
          }
        }
      }
      .right {
        margin-top: 24px;
        .mobile-table {
          border-radius: 16px;
          background: rgba(60, 28, 24, 1);
          overflow: hidden;
        }
        .mobile-table + .mobile-table {
          margin-top: 10px;
        }
        .table-coin {
          padding: 8px 12px;
          gap: 8px;
          .coin {
            width: 32px;
            height: 32px;
          }
          span {
            color: var(--neutral-color-white-100-primary-text, #fff);
            font-size: 16px;
            font-weight: 700;
          }
        }
        .table-box {
          padding: 12px;
          flex-wrap: wrap;
          background: #000;
        }
        .table-info {
          width: 50%;
        }
        .table-info:nth-child(n + 3) {
          margin-top: 12px;
        }
        .table-title {
          gap: 2px;
          color: var(--neutral-color-white-65-secondary-textr, rgba(255, 255, 255, 0.65));
          font-size: 12px;
          img {
            width: 16px;
            height: 16px;
          }
        }
        .table-detail {
          margin-top: 4px;
          color: var(--neutral-color-white-100-primary-text, #fff);
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
    .pool {
      .info {
        flex-wrap: wrap;
        padding: 16px 12px 0 12px;
        border-radius: 24px 24px 0 0;
        background: var(--agniBG, rgba(47, 40, 40, 0.5));
        div:nth-child(1) {
          width: 100%;
        }
        div:not(:nth-child(1)) {
          margin-top: 24px;
          width: 50%;
        }
        p {
          color: rgba(255, 255, 255, 0.45);
          font-size: 12px;
        }
        h4 {
          margin-top: 12px;
          color: #fff;
          font-size: 20px;
          font-weight: 700;
        }
      }
      .table-container {
        padding: 24px 12px 16px 12px;
        border-radius: 0 0 24px;
        background: var(--agniBG, rgba(47, 40, 40, 0.5));
        overflow: hidden;
        .mobile-table {
          border-radius: 16px;
          background: rgba(60, 28, 24, 1);
          overflow: hidden;
        }
        .mobile-table + .mobile-table {
          margin-top: 10px;
        }
        .table-coin {
          padding: 8px 12px;
          gap: 8px;
          .coin {
            width: 32px;
            height: 32px;
          }
          span {
            color: var(--neutral-color-white-100-primary-text, #fff);
            font-size: 16px;
            font-weight: 700;
          }
        }
        .table-box {
          padding: 12px;
          flex-wrap: wrap;
          align-items: stretch;
          background: #000;
        }
        .table-info {
          width: 50%;
        }
        .table-info:nth-child(n + 3) {
          margin-top: 12px;
        }
        .table-title {
          gap: 2px;
          color: var(--neutral-color-white-65-secondary-textr, rgba(255, 255, 255, 0.65));
          font-size: 12px;
          img {
            width: 16px;
            height: 16px;
          }
        }
        .table-detail {
          margin-top: 4px;
          color: var(--neutral-color-white-100-primary-text, #fff);
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
`

const InternalModalTitle = styled.span`
  color: #fff;
  font-size: 16px;
  font-weight: 700;
`

const InternalModal = styled.div`
  @media not screen and (max-width: 1280px) {
    padding: 0 24px 24px 24px;
    width: 540px;
    .tips {
      margin-bottom: 24px;
      color: #fff;
      font-size: 14px;
    }
    .box-group {
      position: relative;
      padding-bottom: 6px;
      .convert {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: 1;
      }
    }
    .countdown {
      position: absolute;
      inset: 0 0 0 0;
      padding: 0 44px;
      border-radius: 16px;
      background: rgba(0, 0, 0, 0.65);
      backdrop-filter: blur(8px);
      z-index: 1;
      .time {
        align-items: flex-end;
        span {
          color: #f4c470;
          margin-right: 4px;
          font-size: 32px;
          font-weight: 700;
        }
        b {
          padding-bottom: 2px;
          color: #f4c470;
          font-size: 16px;
          font-weight: 400;
        }
        span + b {
          margin-right: 8px;
        }
      }
      p {
        margin-top: 16px;
        color: var(--neutral-color-white-65-secondary-textr, rgba(255, 255, 255, 0.65));
        text-align: center;
        font-size: 14px;
        line-height: 120%;
      }
    }
    .box {
      padding: 8px 16px;
      border-radius: 16px;
      background: var(--neutral-color-white-8, rgba(255, 255, 255, 0.08));
      overflow: hidden;
    }
    .convert {
      width: 32px;
      height: 32px;
    }
    .convert + .box {
      margin-top: 2px;
    }
    .box-inner {
      .balance {
        margin-bottom: 8px;
        h4 {
          color: #fff;
          font-size: 16px;
          font-weight: 700;
        }
        p {
          color: rgba(255, 255, 255, 0.65);
          font-size: 14px;
        }
      }
      .entry {
        padding: 16px 0;
        .input {
          label {
            height: 24px;
            background: transparent;
          }
          input {
            line-height: 24px;
            &::placeholder {
              color: rgba(254, 255, 212, 0.2);
            }
          }
        }
        .show {
          padding: 0 12px;
          font-size: 16px;
          font-weight: 700;
        }
        .active {
          color: #fff;
        }
        .default {
          color: rgba(254, 255, 212, 0.2);
        }
        .handle {
          padding-left: 16px;
          gap: 16px;
        }
        .all {
          color: #f4c470;
          font-size: 14px;
        }
        .coin {
          padding: 4px 4px 4px 6px;
          gap: 6px;
          border-radius: 8px;
          background: var(--neutral-color-white-8, rgba(255, 255, 255, 0.08));
          img {
            width: 20px;
            height: 20px;
          }
          p {
            color: #fff;
            font-size: 14px;
          }
          svg {
            fill: #fff;
          }
        }
      }
    }
    .info {
      margin-top: 10px;
      P {
        color: rgba(255, 255, 255, 0.65);
        font-size: 16px;
      }
      h4 {
        color: var(--neutral-color-white-100-primary-text, #fff);
        font-size: 16px;
        font-weight: 400;
      }
      .more {
        gap: 4px;
      }
    }
    .line {
      margin-top: 16px;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.08);
    }
    button {
      margin: 16px 0;
    }
    .more-tips {
      h4 {
        margin-bottom: 8px;
        color: rgba(255, 255, 255, 0.65);
        font-size: 12px;
        font-weight: 700;
      }
      p {
        color: rgba(255, 255, 255, 0.65);
        font-size: 12px;
        line-height: 14px;
      }
    }
    .more-staked {
      p {
        color: rgba(255, 255, 255, 0.65);
        font-size: 16px;
      }
      h4 {
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  @media screen and (max-width: 1280px) {
    padding: 0 16px 32px 16px;
    .tips {
      margin-bottom: 12px;
      color: rgba(255, 255, 255, 0.65);
      font-size: 12px;
    }
    .box-group {
      position: relative;
      padding-bottom: 6px;
      .convert {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: 1;
      }
    }
    .countdown {
      position: absolute;
      inset: 0 0 0 0;
      padding: 0 32px;
      border-radius: 16px;
      background: rgba(0, 0, 0, 0.65);
      backdrop-filter: blur(8px);
      z-index: 1;
      .time {
        align-items: flex-end;
        span {
          color: #f4c470;
          margin-right: 4px;
          font-size: 32px;
          font-weight: 700;
        }
        b {
          padding-bottom: 2px;
          color: #f4c470;
          font-size: 16px;
          font-weight: 400;
        }
        span + b {
          margin-right: 8px;
        }
      }
      p {
        margin-top: 16px;
        color: var(--neutral-color-white-65-secondary-textr, rgba(255, 255, 255, 0.65));
        text-align: center;
        font-size: 14px;
        line-height: 120%;
      }
    }
    .box {
      padding: 8px 16px;
      border-radius: 16px;
      background: var(--neutral-color-white-8, rgba(255, 255, 255, 0.08));
      overflow: hidden;
    }
    .convert {
      width: 32px;
      height: 32px;
    }
    .convert + .box {
      margin-top: 2px;
    }
    .box-inner {
      .balance {
        margin-bottom: 8px;
        h4 {
          color: #fff;
          font-size: 16px;
          font-weight: 700;
        }
        p {
          color: rgba(255, 255, 255, 0.65);
          font-size: 12px;
        }
      }
      .entry {
        height: 48px;
        .input {
          flex: 1;
          label {
            padding: 0;
            height: 48px;
            background: transparent;
          }
          input {
            width: 160px;
            max-width: 100%;
            font-size: 20px;
            line-height: 48px;
            &::placeholder {
              color: rgba(254, 255, 212, 0.2);
            }
          }
        }
        .show {
          font-size: 20px;
          font-weight: 700;
        }
        .active {
          color: #fff;
        }
        .default {
          color: rgba(254, 255, 212, 0.2);
        }
        .handle {
          gap: 16px;
        }
        .all {
          color: #f4c470;
          font-size: 14px;
        }
        .coin {
          padding: 4px 4px 4px 6px;
          gap: 6px;
          border-radius: 8px;
          background: var(--neutral-color-white-8, rgba(255, 255, 255, 0.08));
          img {
            width: 20px;
            height: 20px;
          }
          p {
            color: #fff;
            font-size: 14px;
          }
          svg {
            fill: #fff;
          }
        }
      }
    }
    .info {
      margin-top: 10px;
      P {
        color: rgba(255, 255, 255, 0.65);
        font-size: 14px;
      }
      h4 {
        color: var(--neutral-color-white-100-primary-text, #fff);
        font-size: 14px;
        font-weight: 400;
      }
      .more {
        gap: 4px;
      }
    }
    .line {
      margin-top: 16px;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.08);
    }
    button {
      margin: 16px 0;
    }
    .more-tips {
      h4 {
        margin-bottom: 8px;
        color: rgba(255, 255, 255, 0.65);
        font-size: 12px;
        font-weight: 700;
      }
      p {
        color: rgba(255, 255, 255, 0.65);
        font-size: 12px;
        line-height: 14px;
      }
    }
    .more-staked {
      p {
        color: rgba(255, 255, 255, 0.65);
        font-size: 16px;
      }
      h4 {
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
`

const DesktopDropdown = styled.div`
  margin-top: 4px;
  min-width: 240px;
  max-width: 280px;
  padding: 12px;
  border-radius: 16px;
  background: #595959;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.16);
  li {
    gap: 24px;
    img {
      margin-right: 4px;
      width: 20px;
      height: 20px;
    }
    p {
      color: #fff;
      font-size: 14px;
    }
    span {
      margin-left: 4px;
      min-width: 24px;
      height: 16px;
      padding: 0px 3px;
      border-radius: 4px;
      background: var(--Background-01, rgba(244, 196, 112, 0.12));
      color: #f4c470;
      font-size: 12px;
    }
  }
  li + li {
    margin-top: 12px;
  }
  hr {
    margin: 12px 0;
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
  }
  .tip {
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    line-height: 120%;
  }
`

const InternalResultModal = styled.div`
  @media not screen and (max-width: 1280px) {
    padding: 0 24px;
    width: 480px;
    img {
      width: 128px;
      height: 128px;
    }
    h4 {
      margin: 16px 0;
      color: var(--neutral-color-white-100-primary-text, #fff);
      font-size: 24px;
      font-weight: 700;
    }
    p {
      margin-bottom: 4px;
      color: rgba(255, 255, 255, 0.65);
      text-align: center;
      font-size: 14px;
      line-height: 120%;
    }
    .add {
      margin-bottom: 24px;
      color: #f4c470;
      font-size: 14px;
      line-height: 120%;
    }
    .enjoy {
      width: 100%;
      div {
        padding: 8px 10px;
        border-radius: 12px;
        background: #3a3a3a;
        color: var(--text-01100, #f4c470);
        font-size: 14px;
        font-style: italic;
        font-weight: 500;
      }
    }
  }
  @media screen and (max-width: 1280px) {
    padding: 16px 16px 32px 16px;
    img {
      width: 100px;
      height: 100px;
    }
    h4 {
      margin: 16px 0;
      color: var(--neutral-color-white-100-primary-text, #fff);
      font-size: 20px;
      font-weight: 700;
    }
    p {
      margin-bottom: 16px;
      color: rgba(255, 255, 255, 0.65);
      text-align: center;
      font-size: 12px;
      line-height: 110%;
    }
    .add {
      color: #f4c470;
      font-size: 14px;
    }
    .enjoy {
      width: 100%;
      div {
        padding: 8px 10px;
        border-radius: 12px;
        background: #3a3a3a;
        color: var(--text-01100, #f4c470);
        font-size: 14px;
        font-style: italic;
        font-weight: 500;
      }
    }
  }
`

const DECIMAL_TWO = 2 as const

const IndexPage = () => {
  // 钱包
  const { data: walletClient } = useWalletClient()
  const { isMobile } = useMatchBreakpoints()

  const [symbolData, setSymbolData] = React.useState<string>('')

  const loadSymbolData = React.useCallback(async () => {
    const liquidityCompositions = await SdkProvider.getApi()
      .dashBoardApi()
      .liquidityComposition(SdkProvider.currentChainType)
    // console.log(liquidityCompositions);
    const result = liquidityCompositions.map((ele) => ele.token.symbol).join(', ')
    setSymbolData(result)
  }, [])

  useMount(() => {
    loadSymbolData()
  })

  const filterALPDecimal = React.useMemo(() => {
    return getPrecision('PLP').personal
  }, [])

  const [priceChart, setPriceChart] = React.useState<DashboardGLPPriceHistory[]>([])
  const [priceInfo, setPriceInfo] = React.useState<DashboardGLPPrice>()

  const loadPriceData = React.useCallback(async () => {
    const dashBoardApi = SdkProvider.getApi().dashBoardApi()
    const priceHistories = await dashBoardApi.priceHistory(SdkProvider.currentChainType)
    // console.log('Price Histories', priceHistories)
    setPriceChart(priceHistories)
    const dashboardGLPPrice = await dashBoardApi.price(SdkProvider.currentChainType, walletClient?.account?.address)
    setPriceInfo(dashboardGLPPrice)
  }, [walletClient])

  const [detailInfo, setDetailInfo] = React.useState<DashboardGLPLiquidityComposition[]>([])
  const [detailTotal, setDetailTotal] = React.useState<number>(0)
  const [detailWeight, setDetailWeight] = React.useState<{ token: string; value: number }[]>([])

  const loadDetailData = React.useCallback(async () => {
    const liquidityCompositions = await SdkProvider.getApi()
      .dashBoardApi()
      .liquidityComposition(SdkProvider.currentChainType)
    // console.log(liquidityCompositions);
    setDetailInfo(liquidityCompositions)

    const sum = liquidityCompositions.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.totalValue)
    }, 0)
    // console.log(sum);
    setDetailTotal(sum)

    const [first, ...rest] = liquidityCompositions.map((ele) => {
      return { token: ele.token.symbol, value: Number(filterPrecision(ele.currentWeight, 1)) }
    })
    const fold = 100 - rest.reduce((accumulator, currentValue) => accumulator + currentValue.value, 0)
    const newValue = [{ token: first.token, value: fold }, ...rest]
    // console.log(newValue)
    setDetailWeight(newValue)
  }, [])

  const columns1: ColumnObjectType[] = React.useMemo(() => {
    return [
      {
        key: 'tokenName',
        title: 'Coin',
      },
      {
        key: 'tokenQuantity',
        title: 'Token Quantity',
      },
      {
        key: 'totalValue',
        title: 'Total Value',
      },
      {
        key: 'fee',
        title: (
          <div className="row-start">
            <span>
              Reference Buy/
              <br />
              Sell Fee
            </span>
            <TooltipNew title={<p>Reference fees for buying/selling 10,000 USD worth of PLP in different coins.</p>}>
              <img className="hover" src="/newImages/perp/icon-question.svg" alt="icon" />
            </TooltipNew>
          </div>
        ),
      },
      {
        key: 'weight',
        title: (
          <div className="row-start">
            <span>
              Target Weight/
              <hr />
              Current Weigh
            </span>
          </div>
        ),
      },
    ]
  }, [])

  const dataSource1: TableObjectType[] = React.useMemo(() => {
    return detailInfo.map((ele) => {
      return {
        key: ele.token.address,
        tokenName: (
          <div className="row-start">
            <ContainerCoin className="coin" address={ele.token.logoURI} />
            <span>{ele.token.symbol}</span>
          </div>
        ),
        tokenQuantity: <div>{filterThousands(ele.tokenQuantity)}</div>,
        totalValue: <div>${filterThousands(ele.totalValue)}</div>,
        fee: (
          <div>
            {filterThousands(ele.buyFee, DECIMAL_TWO)}% / {filterThousands(ele.sellFee, DECIMAL_TWO)}%
          </div>
        ),
        weight: (
          <div>
            {filterThousands(ele.targetWeight, DECIMAL_TWO)}% / {filterThousands(ele.currentWeight, DECIMAL_TWO)}%
          </div>
        ),
      }
    })
  }, [detailInfo])

  const [poolInfo, setPoolInfo] = React.useState<DashboardGLPPoolPosition>()
  const [poolList, setPoolList] = React.useState<DashboardGLPPoolPosition['pools']>([])

  const filterUnit = React.useCallback((value?: string) => {
    if (!value || Number(value) >= 0) return { unit: '+', className: 'up' }
    return { unit: '', className: 'down' }
  }, [])

  const loadPoolData = React.useCallback(async () => {
    const glpPoolPosition = await SdkProvider.getApi().dashBoardApi().poolPosition(SdkProvider.currentChainType)
    // console.log(glpPoolPosition)
    setPoolInfo(glpPoolPosition)
    setPoolList(glpPoolPosition.pools)
  }, [])

  const columns2: ColumnObjectType[] = React.useMemo(() => {
    return [
      {
        key: 'tokenName',
        title: 'Symbol',
      },
      {
        key: 'longOl',
        title: 'Long OI (USD)',
      },
      {
        key: 'shortOl',
        title: 'Short OI (USD)',
      },
      {
        key: 'netOl',
        title: 'Net OI (USD)',
      },
      {
        key: 'unrealizedPNL',
        title: 'Unrealized PNL(USD)',
      },
    ]
  }, [])

  const dataSource2: TableObjectType[] = React.useMemo(() => {
    return poolList.map((ele, index) => {
      return {
        key: index,
        tokenName: ele.symbol,
        longOl: filterPrecision(ele.longOl),
        shortOl: filterPrecision(ele.shortOl),
        netOl: (
          <div className={`${filterUnit(ele.netOl).className}`}>
            {filterUnit(ele.netOl).unit}
            {filterPrecision(ele.netOl)}
          </div>
        ),
        unrealizedPNL: (
          <div className={`${filterUnit(ele.unrealizedPNL).className}`}>
            {filterUnit(ele.unrealizedPNL).unit}
            {filterPrecision(ele.unrealizedPNL)}
          </div>
        ),
      }
    })
  }, [filterUnit, poolList])

  // useMount(() => {
  //   loadPriceData()
  //   loadDetailData()
  // })

  useInterval(
    () => {
      loadPriceData()
      loadDetailData()
      loadPoolData()
    },
    3_000,
    { immediate: true },
  )

  // ------------------------ Modal ------------------------
  const [allTokenList, setAllTokenList] = React.useState<BuySellTokenBalance[]>([])
  const [allToken, setAllToken] = React.useState<BuySellTokenBalance>()
  const [invert, setInvert] = React.useState<boolean>(true)

  const loadAllData = React.useCallback(async () => {
    const chainType = SdkProvider.currentChainType
    const buySellGLPApi = SdkProvider.getApi().buySellGLPApi()
    const connectInfo = SdkProvider.connect()

    // 获取token列表 | 初始化
    const tokenBalances = await buySellGLPApi.tokens(chainType, connectInfo.account)
    // console.log(tokenBalances)
    setAllTokenList(tokenBalances)
    const balance = tokenBalances[0]
    setAllToken(balance)
  }, [])

  const [modalState, setModalState] = React.useState<'Buy' | 'Sell'>('Buy')
  const [buyVisible, setBuyVisible] = React.useState<boolean>(false)
  const [sellVisible, setSellVisible] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (!buyVisible && !sellVisible) return
    loadAllData()
  }, [buyVisible, sellVisible, loadAllData])

  const [allLoading, setAllLoading] = React.useState<boolean>(false)
  const [allState, setAllState] = React.useState<'successful' | 'failed'>('successful')
  const [allStateVisible, setAllStateVisible] = React.useState<boolean>(false)

  // ------------------------ Buy ------------------------
  const [buyInfo, setBuyInfo] = React.useState<BuyGLPInfo>()

  const [buyInput, setBuyInput] = React.useState<string>('')
  const [buyPreInfo, setBuyPreInfo] = React.useState<PreBuyGLPInfo>()
  const [buyShowApprove, setBuyShowApprove] = React.useState<boolean>(false)

  const loadBuyInfoData = React.useCallback(async () => {
    if (!allToken) return
    const chainType = SdkProvider.currentChainType
    const buySellGLPApi = SdkProvider.getApi().buySellGLPApi()
    const connectInfo = SdkProvider.connect()
    const buyGLPInfo = await buySellGLPApi.buyInfo(chainType, allToken.token, connectInfo.account)
    // console.log(buyGLPInfo)
    setBuyInfo(buyGLPInfo)

    const preBuyGLPInfo = await buyGLPInfo.preBuy(buyInput || '0')
    const showApprove = await buyGLPInfo.balance.showApprove(buyInput || '0')
    // console.log(preBuyGLPInfo, showApprove, buyInput)
    setBuyPreInfo(preBuyGLPInfo)
    setBuyShowApprove(showApprove)

    setAllLoading(false)
  }, [buyInput, allToken])

  // 暂存上次交易GLP
  const [buyStagingGLP, setBuyStagingGLP] = React.useState<string>('0')

  React.useEffect(() => {
    if (!buyInput || !buyPreInfo) return
    setBuyStagingGLP(buyPreInfo.youWillGet)
  }, [buyInput, buyPreInfo])

  React.useEffect(() => {
    if (!buyVisible) return
    loadBuyInfoData()
  }, [buyVisible, buyInput, loadBuyInfoData])

  const handleBuy = React.useCallback(async () => {
    if (!buyInfo) return
    setAllLoading(true)
    const connectInfo = SdkProvider.connect()

    if (buyShowApprove) {
      try {
        // 发起交易
        const transactionEvent = await buyInfo.balance.approve(connectInfo)
        // 等待交易确认
        await transactionEvent.confirm()
        loadBuyInfoData()
        // console.log('交易完成')
      } catch (e: any) {
        // console.log('交易失败', e.message)
        setAllLoading(false)
      }
      return
    }

    try {
      // 发起交易
      const transactionEvent = await buyInfo.buy(buyInput, connectInfo)
      // 等待交易确认
      await transactionEvent.confirm()
      setBuyInput('')
      loadBuyInfoData()
      // console.log('交易完成')
      setBuyVisible(false)
      setAllState('successful')
      setAllStateVisible(true)
    } catch (e: any) {
      // console.log('交易失败', e.message)
      setAllLoading(false)
      setBuyVisible(false)
      setAllState('failed')
      setAllStateVisible(true)
    }
  }, [buyInfo, buyInput, buyShowApprove, loadBuyInfoData])

  const handleAddGLP = React.useCallback(async () => {
    const connectInfo = SdkProvider.connect()
    await connectInfo.addToken(connectInfo.chainInfo().GLP)
  }, [])

  // ------------------------ Sell ------------------------
  const [sellInfo, setSellInfo] = React.useState<SellGLPInfo>()

  const [sellInput, setSellInput] = React.useState<string>('')
  const [sellPreInfo, setSellPreInfo] = React.useState<PreSellGLPInfo>()
  const [sellShowApprove, setSellShowApprove] = React.useState<boolean>(false)

  const loadSellInfoData = React.useCallback(async () => {
    if (!allToken) return
    const chainType = SdkProvider.currentChainType
    const buySellGLPApi = SdkProvider.getApi().buySellGLPApi()
    const connectInfo = SdkProvider.connect()

    const sellGLPInfo = await buySellGLPApi.sellInfo(chainType, allToken.token, connectInfo.account)
    // console.log(sellGLPInfo)
    setSellInfo(sellGLPInfo)

    const preSellGLPInfo = await sellGLPInfo.preSell(sellInput || '0')
    const showApprove = sellGLPInfo.balance.showApprove(sellInput || '0')
    // console.log('preSellGLPInfo', preSellGLPInfo, showApprove, sellInput)
    setSellPreInfo(preSellGLPInfo)
    setSellShowApprove(showApprove)

    setAllLoading(false)
  }, [sellInput, allToken])

  React.useEffect(() => {
    if (!sellVisible) return
    loadSellInfoData()
  }, [sellVisible, sellInput, loadSellInfoData])

  const handleSell = React.useCallback(async () => {
    if (!sellInfo) return
    setAllLoading(true)
    const connectInfo = SdkProvider.connect()

    if (sellShowApprove) {
      try {
        // 发起交易
        const transactionEvent = await sellInfo.balance.approve(connectInfo)
        // 等待交易确认
        await transactionEvent.confirm()
        loadSellInfoData()
        // console.log('交易完成')
      } catch (e: any) {
        // console.log('交易失败', e.message)
        setAllLoading(false)
      }
      return
    }

    try {
      // 发起交易
      const transactionEvent = await sellInfo.sell(sellInput, connectInfo)
      // 等待交易确认
      await transactionEvent.confirm()
      setSellInput('')
      loadSellInfoData()
      // console.log('交易完成')
      setSellVisible(false)
      setAllState('successful')
      setAllStateVisible(true)
    } catch (e: any) {
      // console.log('交易失败', e.message)
      setAllLoading(false)
      setSellVisible(false)
      setAllState('failed')
      setAllStateVisible(true)
    }
  }, [sellInfo, sellInput, sellShowApprove, loadSellInfoData])

  const [countdown, formattedRes] = useCountDown({
    leftTime: sellInfo ? sellInfo.countDown * 1_000 : 0,
  })
  const { hours, minutes, seconds } = formattedRes

  return (
    <>
      <Wrapper>
        <div className="inner">
          <h2 className="title">PLP Dashboard</h2>
          <p className="title-tips">
            Buy PLP with {symbolData} Cake to share PLP Pool trading profits. Stake PLP to earn extra rewards.
          </p>
          <div className="labor">
            <div className="coin row-start">
              <ContainerCoin address="/newImages/perp/icon-coin_gby_lp.png" />
              <h3>PLP Price</h3>
            </div>
            <div className="labor-box row-between">
              <div className="box chart row-center">
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={priceChart} margin={{ bottom: -8 }}>
                    <defs>
                      <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#f4c470" stopOpacity={0.5} />
                        <stop offset="100%" stopColor="#f4c470" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <XAxis dataKey="time" tickLine={false} tickFormatter={(time) => `${dayjs(time).format('MM/DD')}`} />
                    <Tooltip
                      cursor={{ stroke: '#f4c470' }}
                      contentStyle={{
                        borderRadius: 4,
                        background: 'rgba(51, 45, 42, 0.75)',
                        backdropFilter: 'blur(2px)',
                        border: 'none',
                        outline: 'none',
                        overflow: 'hidden',
                        // color: 'rgba(255, 255, 255, 0.85)',
                        // fontSize: 14,
                        // pointerEvents: 'auto',
                      }}
                      // formatter={(value, name, props) => {
                      //   const formattedTime = dayjs(props.payload.time).format('MMM D, YYYY')
                      //   return [`${formattedTime}: $${value}`, name]
                      // }}
                      labelFormatter={(label) => dayjs(label).format('MMM D, YYYY')}
                      formatter={(value) => {
                        return [`${filterThousands(value as string)}`, 'Price']
                      }}
                    />
                    <Area dataKey="price" type="monotone" stroke="#f4c470" fill="url(#gradient)" strokeWidth={3} />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
              <hr />
              <div className="box">
                <div className="info row-between">
                  <TooltipNew title={<p>PLP price calculation formula: PLP total value / PLP total supply</p>}>
                    <h4 className="hover dotted-line">PLP Price</h4>
                  </TooltipNew>
                  <p>{filterThousands(priceInfo?.GLPPrice ?? 0)} USD</p>
                </div>
                <div className="info row-between">
                  <TooltipNew title={<p>Total supply refers to the total PLP distributed by the smart contract</p>}>
                    <h4 className="hover dotted-line">Total Supply</h4>
                  </TooltipNew>
                  <p>{filterThousands(priceInfo?.totalSupply ?? 0)} PLP</p>
                </div>
                <div className="info row-between">
                  <TooltipNew title={<p>Total Value is the product of total Supply and PLP price</p>}>
                    <h4 className="hover dotted-line">Total Value</h4>
                  </TooltipNew>
                  <p>{filterThousands(priceInfo?.totalValue ?? 0)} USD</p>
                </div>
                <div className="info info-only row-between">
                  <TooltipNew title={<p>PLP Balance of current connected wallet</p>}>
                    <h4 className="hover dotted-line">PLP Balance</h4>
                  </TooltipNew>
                  <p className="row-end">
                    <svg viewBox="0 0 24 24" color="primary" width="24px">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17 4C18.5 4 19 4.5 19 6L19 8C20.1046 8 21 8.89543 21 10L21 17C21 19 20 20 17.999 20H6C4 20 3 19 3 17L3 7C3 5.5 4.5 4 6 4L17 4ZM5 7C5 6.44772 5.44772 6 6 6L19 6L19 8L6 8C5.44772 8 5 7.55229 5 7ZM17 16C18 16 19.001 15 19 14C18.999 13 18 12 17 12C16 12 15 13 15 14C15 15 16 16 17 16Z"
                      />
                    </svg>
                    {filterThousands(priceInfo?.alpBalance ?? 0, filterALPDecimal)}
                  </p>
                </div>
                <div className="button row-between">
                  <ContainerAuth className="button-only">
                    <Button
                      onClick={() => {
                        setBuyVisible(true)
                        setModalState('Buy')
                      }}
                    >
                      Buy PLP
                    </Button>
                  </ContainerAuth>
                  {/* class被劫持，没有透传到子元素上 */}
                  <ContainerAuth className="button-only min" control={false}>
                    <Button
                      type="solid"
                      onClick={() => {
                        setSellVisible(true)
                        setModalState('Sell')
                      }}
                    >
                      Sell PLP
                    </Button>
                  </ContainerAuth>
                </div>
              </div>
            </div>
          </div>
          <h2 className="title">PLP Liquidity Composition</h2>
          <p className="title-tips">
            PLP pool is a dynamic composition of different tokens. Buy and sell fees of tokens depend on market
            conditions.
          </p>
          <div className="detail">
            <h4 className="subtitle">Composition Details</h4>
            <div className="box row-between">
              <div className="left">
                <div className="chart col-center">
                  <Circle
                    className="chart-info"
                    circleSize={isMobile ? 128 : 188}
                    strokeWidth={20}
                    strokeColor={['#f4c470', '#3eac35', '#ff7f3f', '#ea5c2b']}
                    percentArray={detailWeight.map((ele) => ele.value)}
                  />
                  <h4>{filterAbbreviation(detailTotal)} USD</h4>
                  <p>Total PLP pool value</p>
                </div>
                <hr />
                <div className="info row-between">
                  {detailWeight.map((ele, index) => (
                    <div className="only row-start" key={index}>
                      <div className={`dot color_${index}`} />
                      <p>
                        {ele.token}：{filterPrecision(ele.value, 1)}%
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="right">
                {!isMobile && <Table className="table" columns={columns1} dataSource={dataSource1} />}
                {isMobile &&
                  detailInfo.map((ele) => {
                    return (
                      <div key={ele.token.address} className="mobile-table">
                        <div className="table-coin row-start">
                          <ContainerCoin className="coin" address={ele.token.logoURI} />
                          <span>{ele.token.symbol}</span>
                        </div>
                        <div className="table-box row-start">
                          <div className="table-info">
                            <div className="table-title">Coin</div>
                            <div className="table-detail">{filterThousands(ele.tokenQuantity)}</div>
                          </div>
                          <div className="table-info">
                            <div className="table-title">Token Quantity</div>
                            <div className="table-detail">${filterThousands(ele.totalValue)}</div>
                          </div>
                          <div className="table-info">
                            <div className="table-title row-start">
                              <span>Reference Buy</span>
                              <TooltipNew
                                title={
                                  <p>Reference fees for buying/selling 10,000 USD worth of PLP in different coins.</p>
                                }
                              >
                                <img className="hover" src="/newImages/perp/icon-question.svg" alt="icon" />
                              </TooltipNew>
                            </div>
                            <div className="table-detail">{filterThousands(ele.buyFee, DECIMAL_TWO)}%</div>
                          </div>
                          <div className="table-info">
                            <div className="table-title row-start">
                              <span>Sell Fee</span>
                              <TooltipNew
                                title={
                                  <p>Reference fees for buying/selling 10,000 USD worth of PLP in different coins.</p>
                                }
                              >
                                <img className="hover" src="/newImages/perp/icon-question.svg" alt="icon" />
                              </TooltipNew>
                            </div>
                            <div className="table-detail">{filterThousands(ele.sellFee, DECIMAL_TWO)}%</div>
                          </div>
                          <div className="table-info">
                            <div className="table-title">Target Weight</div>
                            <div className="table-detail">{filterThousands(ele.targetWeight, DECIMAL_TWO)}%</div>
                          </div>
                          <div className="table-info">
                            <div className="table-title">Current Weigh</div>
                            <div className="table-detail">{filterThousands(ele.currentWeight, DECIMAL_TWO)}%</div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
          <h2 className="title">PLP Pool Position</h2>
          <p className="title-tips">Information about PLP Pool Position.</p>
          <div className="pool">
            <div className="info row-between">
              <div>
                <p>Total OI</p>
                <h4>{filterAbbreviation(poolInfo?.totalOl ?? 0)} USD</h4>
              </div>
              <div>
                <p>Long OI(USD)</p>
                <h4>{filterPrecision(poolInfo?.longOl ?? 0)}</h4>
              </div>
              <div>
                <p>Short OI(USD)</p>
                <h4>{filterPrecision(poolInfo?.shortOl ?? 0)}</h4>
              </div>
              <div>
                <p>Net OI(USD)</p>
                <h4>
                  {filterUnit(poolInfo?.netOl).unit}
                  {filterPrecision(poolInfo?.netOl ?? 0)}
                </h4>
              </div>
              <div>
                <p>Unrealized PNL(USD)</p>
                <h4>
                  {filterUnit(poolInfo?.unrealizedPNL).unit}
                  {filterPrecision(poolInfo?.unrealizedPNL ?? 0)}
                </h4>
              </div>
            </div>
            <div className="table-container">
              {!isMobile && <Table className="table" columns={columns2} dataSource={dataSource2} />}
              {isMobile &&
                poolList.map((ele, index) => {
                  return (
                    <div key={index} className="mobile-table">
                      <div className="table-coin">
                        <span>{ele.symbol}</span>
                      </div>
                      <div className="table-box row-start">
                        <div className="table-info">
                          <div className="table-title">Long OI (USD)</div>
                          <div className="table-detail">{filterPrecision(ele.longOl)}</div>
                        </div>
                        <div className="table-info">
                          <div className="table-title">Short OI (USD)</div>
                          <div className="table-detail">{filterPrecision(ele.shortOl)}</div>
                        </div>
                        <div className="table-info">
                          <div className="table-title">Net OI (USD)</div>
                          <div className={`table-detail ${filterUnit(ele.netOl).className}`}>
                            {filterUnit(ele.netOl).unit}
                            {filterPrecision(ele.netOl)}
                          </div>
                        </div>
                        <div className="table-info">
                          <div className="table-title">Unrealized PNL(USD)</div>
                          <div className={`table-detail ${filterUnit(ele.unrealizedPNL).className}`}>
                            {filterUnit(ele.unrealizedPNL).unit}
                            {filterPrecision(ele.unrealizedPNL)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </Wrapper>
      {/* <FooterNew /> */}
      <Modal
        visible={buyVisible}
        title={<InternalModalTitle>Buy</InternalModalTitle>}
        onClose={() => {
          setBuyVisible(false)
          setBuyInput('')
        }}
      >
        <InternalModal>
          <p className="tips">After PLP is successfully bought, the contract will create new PLP.</p>
          <div className="box-group">
            <div className="box">
              <div className="box-inner">
                <div className="balance row-between">
                  <h4>Pay</h4>
                  <p>Available balance: {filterThousands(buyInfo?.balance.balance ?? 0)}</p>
                </div>
                <div className="entry row-between">
                  <Input
                    className="input"
                    placeholder="0.0000"
                    value={buyInput}
                    onChange={(v) => {
                      if (!buyInfo) return
                      if (v && verifyValidNumber(v)) return
                      if (Number(v) > Number(buyInfo.balance.balance)) return
                      setBuyInput(v)
                    }}
                  />
                  <div className="handle row-end">
                    <div
                      className="all hover"
                      onClick={() => {
                        setBuyInput(filterPrecision(buyInfo?.balance.balance ?? 0))
                      }}
                      aria-hidden
                    >
                      All
                    </div>
                    <Trigger
                      placement="bottomRight"
                      trigger={
                        <DesktopDropdown>
                          <ul>
                            {allTokenList.map((ele) => (
                              <li
                                className="hover row-between"
                                key={ele.token.symbol}
                                onClick={() => {
                                  setAllToken(ele)
                                }}
                                aria-hidden
                              >
                                <div className="row-start">
                                  <ContainerCoin address={ele.token.logoURI} />
                                  <p>{ele.token.symbol}</p>
                                </div>
                                <div className="row-end">
                                  <p>{filterThousands(ele.balance)}</p>
                                  <span className="row-center">{ele.buyFee}%</span>
                                </div>
                              </li>
                            ))}
                          </ul>
                          <hr />
                          <p className="tip">
                            Fees are calculated after you have selected the amount of PLP you wish to buy.
                          </p>
                        </DesktopDropdown>
                      }
                      action="click"
                      zIndex={999999}
                    >
                      <div className="coin hover row-start">
                        <ContainerCoin address={allToken?.token.logoURI} />
                        <p>{allToken?.token.symbol ?? '--'}</p>
                        <IconSelectArrow />
                      </div>
                    </Trigger>
                  </div>
                </div>
              </div>
            </div>
            <img className="convert" src="/newImages/perp/arrow_bottom.svg" alt="icon" />
            <div className="box">
              <div className="box-inner">
                <div className="balance row-between">
                  <h4>Get</h4>
                  <p>balance: {filterThousands(buyInfo?.glpBalance ?? 0)}</p>
                </div>
                <div className="entry row-between">
                  <div
                    className={`show ${buyInput && buyPreInfo && buyPreInfo.youWillGet !== '0' ? 'active' : 'default'}`}
                  >
                    {filterThousands(buyInput ? buyPreInfo?.youWillGet ?? 0 : 0)}
                  </div>
                  <div className="handle row-end">
                    <div className="coin row-start">
                      <ContainerCoin address="/newImages/perp/icon-coin_gby_lp.png" />
                      <p>PLP</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="info row-between">
            <p>Est. Price</p>
            <div className="more row-end">
              <img
                className="hover"
                src="/newImages/perp/icon-exchange.svg"
                alt="icon"
                onClick={() => {
                  setInvert((v) => !v)
                }}
                aria-hidden
              />
              {invert ? (
                <h4>
                  1 {allToken?.token.symbol ?? '--'} = {filterThousands(buyInfo?.price ?? 0)} PLP
                </h4>
              ) : (
                <h4>
                  1 PLP = {filterThousands(buyInfo?.priceInvert ?? 0)} {allToken?.token.symbol ?? '--'}
                </h4>
              )}
              <img className="hover" src="/newImages/perp/icon-ReloadOutlined.svg" alt="icon" />
            </div>
          </div>
          <div className="info row-between">
            <p>Fee</p>
            <h4>{buyPreInfo?.feePercent}%</h4>
          </div>
          <div className="info row-between">
            <p>Fee</p>
            <h4>
              {filterThousands(buyPreInfo?.feeAmount ?? 0)} {allToken?.token.symbol}
            </h4>
          </div>
          <div className="info row-between">
            <p>You will get</p>
            <h4>{filterThousands(buyPreInfo?.youWillGet ?? 0)} PLP</h4>
          </div>
          <hr className="line" />
          {false && (
            <div className="info row-between">
              <p>Stake immediately after buying</p>
              <h4 style={{ fontSize: 14 }}>APY: {buyPreInfo?.apy}</h4>
            </div>
          )}
          <Button
            disabled={
              !buyInput ||
              Number(filterPrecision(buyInfo?.balance.balance ?? 0)) === 0 ||
              Number(buyInput) > Number(buyInfo?.balance.balance ?? 0)
            }
            loading={allLoading}
            onClick={handleBuy}
          >
            {buyShowApprove ? 'Approve' : 'Buy PLP'}
          </Button>
          <div className="more-tips">
            <h4>Tips</h4>
            <p>1.After successful buy of PLP, You cannot sell PLP in the first 48 hours after buying.</p>
            {false && <p>2.Stake PLP at any time.</p>}
          </div>
        </InternalModal>
      </Modal>
      <Modal
        visible={sellVisible}
        title="Sell PLP"
        onClose={() => {
          setSellVisible(false)
          setSellInput('')
        }}
      >
        <InternalModal>
          <p className="tips">
            After PLP is successfully sold, the smart contract will burn the PLP involved in this transaction.
          </p>
          <div className="box-group">
            <div className="box">
              <div className="box-inner">
                <div className="balance row-between">
                  <h4>Pay</h4>
                  <p>Available balance: {filterThousands(sellInfo?.balance.balance ?? 0)}</p>
                </div>
                <div className="entry row-between">
                  <Input
                    className="input"
                    placeholder="0.0000"
                    value={sellInput}
                    onChange={(v) => {
                      if (!sellInfo) return
                      if (v && verifyValidNumber(v)) return
                      if (Number(v) > Number(sellInfo.balance.balance)) return
                      setSellInput(v)
                    }}
                  />
                  <div className="handle row-end">
                    <div
                      className="all hover"
                      onClick={() => {
                        setSellInput(filterPrecision(sellInfo?.balance.balance ?? 0))
                      }}
                      aria-hidden
                    >
                      All
                    </div>
                    <div className="coin row-start">
                      <ContainerCoin address="/newImages/perp/icon-coin_gby_lp.png" />
                      <p>PLP</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img className="convert" src="/newImages/perp/arrow_bottom.svg" alt="icon" />
            <div className="box">
              <div className="box-inner">
                <div className="balance row-between">
                  <h4>Get</h4>
                  <p>balance: {filterThousands(sellInfo?.tokenBalance ?? 0)}</p>
                </div>
                <div className="entry row-between">
                  <div className={`show ${sellPreInfo && sellPreInfo.youWillGet !== '0' ? 'active' : 'default'}`}>
                    {filterThousands(sellPreInfo?.youWillGet ?? 0)}
                  </div>
                  <div className="handle row-end">
                    <Trigger
                      placement="bottomRight"
                      trigger={
                        <DesktopDropdown>
                          <ul>
                            {allTokenList.map((ele) => (
                              <li
                                className="hover row-between"
                                key={ele.token.symbol}
                                onClick={() => {
                                  setAllToken(ele)
                                }}
                                aria-hidden
                              >
                                <div className="row-start">
                                  <ContainerCoin address={ele.token.logoURI} />
                                  <p>{ele.token.symbol}</p>
                                </div>
                                <div className="row-end">
                                  <p>{filterThousands(ele.balance)}</p>
                                  <span className="row-center">{ele.sellFee}%</span>
                                </div>
                              </li>
                            ))}
                          </ul>
                          <hr />
                          <p className="tip">
                            Fees are calculated after you have selected the amount of PLP you wish to sell.
                          </p>
                        </DesktopDropdown>
                      }
                      action="click"
                      zIndex={999999}
                    >
                      <div className="coin hover row-start">
                        <ContainerCoin address={allToken?.token.logoURI} />
                        <p>{allToken?.token.symbol ?? '--'}</p>
                        <IconSelectArrow />
                      </div>
                    </Trigger>
                  </div>
                </div>
              </div>
            </div>
            {countdown > 0 && (
              <div className="countdown col-center">
                <div className="time row-center">
                  <span>{hours}</span>
                  <b>h</b>
                  <span>{minutes}</span>
                  <b>m</b>
                  <span>{seconds}</span>
                  <b>s</b>
                </div>
                <p>After successful buy of PLP, You cannot sell PLP in the first {48} hours after buying.</p>
              </div>
            )}
          </div>
          <div className="info row-between">
            <p>Est. Price</p>
            <div className="more row-end">
              <img
                className="hover"
                src="/newImages/perp/icon-exchange.svg"
                alt="icon"
                onClick={() => {
                  setInvert((v) => !v)
                }}
                aria-hidden
              />
              {invert ? (
                <h4>
                  1 {allToken?.token.symbol ?? '--'} = {filterThousands(sellInfo?.price ?? 0)} PLP
                </h4>
              ) : (
                <h4>
                  1 PLP = {filterThousands(sellInfo?.priceInvert ?? 0)} {allToken?.token.symbol ?? '--'}
                </h4>
              )}
              <img className="hover" src="/newImages/perp/icon-ReloadOutlined.svg" alt="icon" />
            </div>
          </div>
          <div className="info row-between">
            <p>Fee</p>
            <h4>{sellPreInfo?.feePercent}%</h4>
          </div>
          <div className="info row-between">
            <p>Fee</p>
            <h4>
              {filterThousands(sellPreInfo?.feeAmount ?? 0)} {allToken?.token.symbol}
            </h4>
          </div>
          <div className="info row-between">
            <p>You will get</p>
            <h4>
              {filterThousands(sellPreInfo?.youWillGet ?? 0)} {allToken?.token.symbol}
            </h4>
          </div>
          <Button
            disabled={
              !sellInput ||
              Number(filterPrecision(sellInfo?.balance.balance ?? 0)) === 0 ||
              Number(sellInput) > Number(sellInfo?.balance.balance ?? 0) ||
              countdown > 0
            }
            loading={allLoading}
            onClick={handleSell}
          >
            {sellShowApprove ? 'Approve' : 'Sell PLP'}
          </Button>
          {false && (
            <div className="more-staked row-between">
              <p>Staked PLP</p>
              <h4>{sellInfo?.stakeGLP}</h4>
            </div>
          )}
        </InternalModal>
      </Modal>
      <Modal
        visible={allStateVisible}
        title=""
        onClose={() => {
          setAllStateVisible(false)
        }}
        // cancel="Maybe Later"
        ok="Done"
        // onCancel={() => {
        //   setAllStateVisible(false)
        // }}
        onOk={() => {
          setAllStateVisible(false)
        }}
      >
        <InternalResultModal>
          {allState === 'successful' && (
            <div className="core col-center">
              <img src="/newImages/perp/icon-modal_success.svg" alt="icon" />
              <h4>Transaction Successful</h4>
              {modalState === 'Buy' && (
                <>
                  <p>{filterThousands(buyStagingGLP)} PLP buy transaction successful.</p>
                  <div className="add hover" onClick={handleAddGLP} aria-hidden>
                    + Add PLP to your wallet
                  </div>
                  {false && (
                    <div className="enjoy row-end">
                      <div>Enjoy {buyPreInfo?.apy} APR by statking PLP.</div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {allState === 'failed' && (
            <div className="core col-center">
              <h4>Transaction Failed</h4>
              <img src="/newImages/perp/icon-modal_failed.svg" alt="icon" />
              <p>This is a recipe for failure.</p>
            </div>
          )}
        </InternalResultModal>
      </Modal>
    </>
  )
}

export default IndexPage
